import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  WarningRuleAudit,
  WarningRuleSkeleton
} from '../../../+models/training-requirement-audit.model';

@Component({
  selector: 'sd-portal-warning-rule-audit-list',
  templateUrl: './warning-rule-audit-list.component.html',
  styleUrls: ['./warning-rule-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarningRuleAuditListComponent implements OnInit {
  @Input() warningRuleSkeletons: WarningRuleSkeleton[];
  @Input() warningRuleAuditLoading: boolean;
  @Input() warningRuleAudits: WarningRuleAudit[];

  @Output() opened = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  onOpened(warningRuleId: number) {
    this.opened.emit(warningRuleId);
  }

  onNextPage(warningRuleId: number) {
    this.nextPage.emit(warningRuleId);
  }
}
